import {utils} from '@wallaby-ui/core';

import * as Comparators from 'src/js/common/components/comparators';
import * as Filters from 'src/js/common/components/filters';
import * as FormatterFunctions from 'src/js/common/components/formatterFunctions';
import * as Formatters from 'src/js/common/components/formatters';
import {LIBRARY_NAME} from 'src/js/common/constants';

const logger = utils.LogUtils.getLogger('FormattersDefinitions', LIBRARY_NAME);

const COLUMN_KEY = 'key';

const AUDIT_LOG_EVENT_FORMATTER = 'AuditLogEventFormatter';
const AUDIT_LOG_EVENT_TYPE_FORMATTER = 'AuditLogEventTypeFormatter';

const CASE_DOCUMENT_LINK_STATEFULL_FORMATTER = 'CaseDocumentLinkStatefullFormatter';
const CASE_PATIENT_AG_FORMATTER = 'CasePatientAGFormatter';
const DATE_FORMATTER = 'DateFormatter';
const DATE_TIME_FORMATTER = 'DateTimeFormatter';
const DECIMAL_WITH_ICON_FORMATTER = 'DecimalWithIconFormatter';
const HOSPITALIZATIONS_DEPARTMENT_FORMATTER = 'HospitalizationsListDepartmentFormatter';
const DOCUMENTS_DEPARTMENT_FORMATTER = 'DocumentsListDepartmentFormatter';
const DOCUMENT_LINK_VALUE_FORMATTER = 'DocumentLinkValueFormatter';
const DOCUMENT_LIST_LINK_FORMATTER = 'DocumentsListLinkFormatter';
const DOCUMENT_NAME_FORMATTER = 'DocumentNameFormatter';
const DECIMAL_FORMATTER = 'DecimalFormatter';
const FILE_DOWNLOAD_FORMATTER = 'FileDownloadFormatter';
const GRADIENT_PROGRESS_FORMATTER = 'GradientProgressFormatter';
const HEALTHCARE_TABLE_EVENT_LINK_FORMATTER = 'HealthcareTableEventLinkFormatter';
const HOSPITALIZATIONS_LINK_FORMATTER = 'HospitalizationsLinkFormatter';
const ICON_FORMATTER = 'IconFormatter';
const INTEGER_FORMATTER = 'IntegerFormatter';
const JUST_TOOLTIP_FORMATTER = 'JustTooltipFormatter';
const MARKER_LIST_FORMATTER = 'MarkerListFormatter';
const MONTH_YEAR_FORMATTER = 'MonthYearFormatter';
const PERCENT_FORMATTER = 'PercentFormatter';
const PROGRESS_FORMATTER = 'ProgressFormatter';
const REPORT_LINK_FORMATTER = 'ReportLinkFormatter';
const RISK_FACTORS_FORMATTER = 'RiskFactorsFormatter';
const RISK_SCORE_FORMATTER = 'RiskScoreFormatter';
const STATUS_ICON_FORMATTER = 'StatusIconFormatter';
const TEXT_FORMATTER = 'TextFormatter';
const TIMELINE_ANNOTATIONS_STATEFULL_FORMATTER = 'TimelineAnnotationsStatefullFormatter';
const TIMELINE_ANNOTATION_TYPE_FORMATTER = 'TimelineAnnotationTypeFormatter';
const HOSPITALIZATION_DETAIL_TIMELINE_ANNOTATION_FORMATTER = 'HospitalizationDetailTimelineAnnotationFormatter';
const HOSPITALIZATION_DETAIL_TIMELINE_EVENT_TYPE_FORMATTER = 'HospitalizationDetailTimelineEventTypeFormatter';
const TOTAL_LABEL_FORMATTER = 'TotalLabelFormatter';
const TRANSLATE_ENUM_FORMATTER = 'TranslateEnumFormatter';
const UNKNOWN_FORMATTER = 'unknown';
const LIST_DEPARTMENT_FORMATTER = 'ListDepartmentFormatter';

const ENCOUNTER_DOCUMENT_LINK_STATEFULL_FORMATTER_FUNCTION = 'EncounterDocumentLinkStatefullFormatterFunction';
const CASE_PATIENT_AG_FORMATTER_FUNCTION = 'CasePatientAGFormatterFunction';
const DATE_FORMATTER_FUNCTION = 'DateFormatterFunction';
const DATE_TIME_FORMATTER_FUNCTION = 'DateTimeFormatterFunction';
const ENCOUNTER_LINK_FORMATTER_FUNCTION = 'DashboardEncounterLinkFormatterFunction';
const HAI_LIST_HAI_LINK_FORMATTER_FUNCTION = 'HaiListHaiLinkFormatterFunction';
const HOSPITALIZATIONS_LIST_LINK_FORMATTER_FUNCTION = 'HospitalizationsListLinkFormatterFunction';
const PATIENT_LIST_LINK_FORMATTER_FUNCTION = 'PatientListLinkFormatterFunction';
const INTEGER_FORMATTER_FUNCTION = 'IntegerFormatterFunction';
const PROGRESS_FORMATTER_FUNCTION = 'ProgressFormatterFunction';
const LINK_FORMATTER_FUNCTION = 'LinkFormatterFunction';
const LIST_FORMATTER_FUNCTION = 'ListFormatterFunction';
const MARKER_LIST_FORMATTER_FUNCTION = 'MarkerListFormatterFunction';
const REPORT_LINK_FORMATTER_FUNCTION = 'ReportLinkFormatterFunction';
const TEXT_FORMATTER_FUNCTION = 'TextFormatterFunction';
const TIMELINE_ANNOTATION_TYPE_FORMATTER_FUNCTION = 'TimelineAnnotationTypeFormatterFunction';
const TIMELINE_ANNOTATIONS_STATEFULL_FORMATTER_FUNCTION = 'TimelineAnnotationsStatefullFormatterFunction';
const TRANSLATE_ENUM_FORMATTER_FUNCTION = 'TranslateEnumFormatterFunction';
const GRID_DATE_ONLY_RANGE_FILTER = 'GridDateOnlyRangeFilter';
const GRID_DATE_RANGE_FILTER = 'GridDateRangeFilter';
const GRID_STATUS_FILTER = 'GridStatusFilter';
const GRID_TEXT_FILTER = 'GridTextFilter';

const AG_UNACCENT_TEXT_COMPARATOR = 'unaccentTextComparator';

const CASE_PATIENT_HOSPITALIZATION_COMPARATOR = 'casePatientHospitalizationComparator';
const DECIMAL_WITH_ICON_COMPARATOR = 'decimalWithIconComparator';
const LOCALIZED_TEXT_COMPARATOR = 'localizedTextComparator';

const CASE_HAI_RF_FORMATTER = 'CaseHaiRFLinkFormatter';
const SPARKLINES_FORMATTER = 'SparklinesFormatter';

const HOSPITALIZATION_PATIENTS_HEADER_FORMATTER = 'HospitalizationPatientsHeaderFormatter';

export const FormattersDefinitions = {
  [AUDIT_LOG_EVENT_FORMATTER]: {
    formatterClass: Formatters.AuditLogEventFormatter,
  },
  [AUDIT_LOG_EVENT_TYPE_FORMATTER]: {
    formatterClass: Formatters.AuditLogEventTypeFormatter,
  },
  // column formatters
  [CASE_DOCUMENT_LINK_STATEFULL_FORMATTER]: {
    formatterClass: Formatters.CaseDocumentLinkStatefullFormatter,
  },
  [CASE_PATIENT_AG_FORMATTER]: {
    formatterClass: Formatters.CasePatientAGFormatter,
  },
  [DATE_FORMATTER]: {
    formatterClass: Formatters.DateFormatter,
  },
  [DATE_TIME_FORMATTER]: {
    formatterClass: Formatters.DateTimeFormatter,
  },
  [HOSPITALIZATIONS_DEPARTMENT_FORMATTER]: {
    formatterClass: Formatters.HospitalizationsListDepartmentFormatter,
  },
  [DOCUMENTS_DEPARTMENT_FORMATTER]: {
    formatterClass: Formatters.DocumentsListDepartmentFormatter,
  },
  [DOCUMENT_LINK_VALUE_FORMATTER]: {
    formatterClass: Formatters.DocumentLinkValueFormatter,
  },
  [DOCUMENT_NAME_FORMATTER]: {
    formatterClass: Formatters.DocumentNameFormatter,
  },
  [DECIMAL_FORMATTER]: {
    formatterClass: Formatters.DecimalFormatter,
  },
  [DOCUMENT_LIST_LINK_FORMATTER]: {
    formatterClass: Formatters.DocumentsListLinkFormatter,
  },
  [FILE_DOWNLOAD_FORMATTER]: {
    columnConfig: {[COLUMN_KEY]: 'downloadData'},
    formatterClass: Formatters.FileDownloadFormatter,
  },
  [GRADIENT_PROGRESS_FORMATTER]: {
    formatterClass: Formatters.GradientProgressFormatter,
  },
  [HEALTHCARE_TABLE_EVENT_LINK_FORMATTER]: {
    formatterClass: Formatters.HealthcareTableEventLinkFormatter,
  },
  [HOSPITALIZATIONS_LINK_FORMATTER]: {
    formatterClass: Formatters.HospitalizationsLinkFormatter,
  },
  [HOSPITALIZATION_DETAIL_TIMELINE_ANNOTATION_FORMATTER]: {
    formatterClass: Formatters.HospitalizationDetailTimelineAnnotationFormatter,
  },
  [HOSPITALIZATION_DETAIL_TIMELINE_EVENT_TYPE_FORMATTER]: {
    formatterClass: Formatters.HospitalizationDetailTimelineEventTypeFormatter,
  },
  [ICON_FORMATTER]: {
    formatterClass: Formatters.IconFormatter,
  },
  [INTEGER_FORMATTER]: {
    formatterClass: Formatters.IntegerFormatter,
  },
  [JUST_TOOLTIP_FORMATTER]: {
    formatterClass: Formatters.JustTooltipFormatter,
  },
  [MARKER_LIST_FORMATTER]: {
    formatterClass: Formatters.MarkerListFormatter,
  },
  [MONTH_YEAR_FORMATTER]: {
    formatterClass: Formatters.MonthYearFormatter,
  },
  [DECIMAL_WITH_ICON_FORMATTER]: {
    formatterClass: Formatters.DecimalWithIconFormatter,
  },
  [PERCENT_FORMATTER]: {
    formatterClass: Formatters.PercentFormatter,
  },
  [PROGRESS_FORMATTER]: {
    formatterClass: Formatters.ProgressFormatter,
  },
  [REPORT_LINK_FORMATTER]: {
    formatterClass: Formatters.ReportLinkFormatter,
  },
  [RISK_FACTORS_FORMATTER]: {
    formatterClass: Formatters.RiskFactorsFormatter,
  },
  [RISK_SCORE_FORMATTER]: {
    formatterClass: Formatters.RiskScoreFormatter,
  },
  [STATUS_ICON_FORMATTER]: {
    formatterClass: Formatters.StatusIconFormatter,
  },
  [TEXT_FORMATTER]: {
    formatterClass: Formatters.TextFormatter,
  },
  [TIMELINE_ANNOTATIONS_STATEFULL_FORMATTER]: {
    columnConfig: {[COLUMN_KEY]: 'uiAnnotations'},
    formatterClass: Formatters.TimelineAnnotationsStatefullFormatter,
  },
  [TIMELINE_ANNOTATION_TYPE_FORMATTER]: {
    columnConfig: {[COLUMN_KEY]: 'uiAnnotations'},
    formatterClass: Formatters.TimelineAnnotationTypeFormatter,
  },
  [TOTAL_LABEL_FORMATTER]: {
    formatterClass: Formatters.TotalLabelFormatter,
  },
  [SPARKLINES_FORMATTER]: {
    formatterClass: Formatters.SparklinesFormatter,
  },
  [CASE_HAI_RF_FORMATTER]: {
    formatterClass: Formatters.CaseHaiRFLinkFormatter,
  },
  [TRANSLATE_ENUM_FORMATTER]: {
    formatterClass: Formatters.TranslateEnumFormatter,
  },
  [TRANSLATE_ENUM_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.translateEnumFormatter,
  },
  [LIST_DEPARTMENT_FORMATTER]: {
    formatterClass: Formatters.ListDepartmentFormatter,
  },

  // formatter functions
  [ENCOUNTER_DOCUMENT_LINK_STATEFULL_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.encounterDocumentLinkStatefullFormatterFunction,
  },
  [CASE_PATIENT_AG_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.casePatientAGFormatterFunction,
  },
  [DATE_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.dateFormatterFunction,
  },
  [DATE_TIME_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.dateTimeFormatterFunction,
  },
  [ENCOUNTER_LINK_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.dashboardEncounterLinkFormatterFunction,
  },
  [HAI_LIST_HAI_LINK_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.haiListHaiLinkFormatter,
  },
  [HOSPITALIZATIONS_LIST_LINK_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.hospitalizationsListLinkFormatter,
  },
  [INTEGER_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.integerFormatterFunction,
  },
  [LINK_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.linkFormatterFunction,
  },
  [LIST_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.listFormatterFunction,
  },
  [MARKER_LIST_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.markerListFormatterFunction,
  },
  [PATIENT_LIST_LINK_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.patientListLinkFormatter,
  },
  [PROGRESS_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.progressFormatterFunction,
  },
  [REPORT_LINK_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.reportLinkFormatterFunction,
  },
  [TEXT_FORMATTER_FUNCTION]: {
    formatterClass: FormatterFunctions.textFormatterFunction,
  },
  [TIMELINE_ANNOTATION_TYPE_FORMATTER_FUNCTION]: {
    columnConfig: {[COLUMN_KEY]: 'uiAnnotations'},
    formatterClass: FormatterFunctions.timelineAnnotationTypeFormatter,
  },
  [TIMELINE_ANNOTATIONS_STATEFULL_FORMATTER_FUNCTION]: {
    columnConfig: {[COLUMN_KEY]: 'uiAnnotations'},
    formatterClass: FormatterFunctions.timelineAnnotationsStatefullFormatterFunction,
  },

  // Header components (formatters)
  [HOSPITALIZATION_PATIENTS_HEADER_FORMATTER]: {
    formatterClass: Formatters.HospitalizationPatientsHeaderFormatter,
  },

  // column filters
  [GRID_DATE_ONLY_RANGE_FILTER]: {
    formatterClass: Filters.GridDateOnlyRangeFilter,
  },
  [GRID_DATE_RANGE_FILTER]: {
    formatterClass: Filters.GridDateRangeFilter,
  },
  [GRID_STATUS_FILTER]: {
    formatterClass: Filters.GridStatusFilter,
  },
  [GRID_TEXT_FILTER]: {
    formatterClass: Filters.GridTextFilter,
  },

  // column filtering comparators
  [AG_UNACCENT_TEXT_COMPARATOR]: {
    formatterClass: Comparators.unaccentTextComparator,
  },

  // column sorting comparators
  [CASE_PATIENT_HOSPITALIZATION_COMPARATOR]: {
    formatterClass: Comparators.casePatientHospitalizationComparator,
  },
  [DECIMAL_WITH_ICON_COMPARATOR]: {
    formatterClass: Comparators.decimalWithIconComparator,
  },
  [LOCALIZED_TEXT_COMPARATOR]: {
    formatterClass: Comparators.localizedTextComparator,
  },
};

export class DynamicFormatter {
  static getFormatterClass(formatterType) {
    let result;
    if (FormattersDefinitions[formatterType]) {
      result = FormattersDefinitions[formatterType].formatterClass;
    } else {
      logger.warn(`Unrecognized formatter type for DynamicFormatter: ${formatterType}`);
      result = FormattersDefinitions[UNKNOWN_FORMATTER].formatterClass;
    }
    return result;
  }

  static getFormatterDefinition(formatterType) {
    return FormattersDefinitions[formatterType];
  }
}

export default {DynamicFormatter};
